<template>
  <div>
    <div class="container">

      <Panel title="Move company" collapsible>
        <div class="group">
          <label>Source branch</label>
          <AjaxSelect v-model="fromBranch" api="/api/entity/branch/select" :allow-empty-search="true"
            :map-fn="(s) => s.name" />
        </div>
        <div class="group">
          <label>Source company</label>
          <AjaxSelect v-model="fromCompany" api="/api/entity/company/select" :query="{ branch: fromBranch.id }"
            :allow-empty-search="true" :map-fn="(s) => s.name" :disabled="!fromBranch.id" />
        </div>
        <div class="group">
          <label>Destination branch</label>
          <AjaxSelect v-model="toBranch" api="/api/entity/branch/select" :allow-empty-search="true"
            :map-fn="(s) => s.name" :ignored="[fromBranch.id]" />
        </div>
        <button class="btn btn-primary" @click="move">Move</button>
      </Panel>

    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex';
  import AjaxSelect from "@/components/tools/AjaxSelect";

  export default {
    name: "MoveCompany",
    components: { AjaxSelect },

    data() {
      return {
        fromBranch: { id: null },
        fromCompany: { id: null },
        toBranch: { id: null }
      }
    },

    watch: {
      "fromBranch.id"(newVal) {
        this.fromCompany = { id: null }
        if (newVal === this.toBranch.id) {
          this.toBranch = { id: null }
        }
      }
    },

    methods: {
      ...mapActions(['saveCompany']),

      async move() {
        let branchId = this.fromBranch.id;
        let companyId = this.fromCompany.id;
        let toBranchId = this.toBranch.id;
        if (!branchId || !companyId || !toBranchId) {
          toast('Every select must have a value selected', 'error');
          return;
        }
        if (branchId === toBranchId) {
          toast('Source branch and destination branch must be different', 'error');
          return;
        }
        let data = {
          branch: toBranchId
        };
        let response = await this.saveCompany({ branchId, companyId, data });
        if (response) {
          toast('Company was moved successfully', "success");
          this.fromBranch = { id: null };
          this.fromCompany = { id: null };
          this.toBranch = { id: null };
        } else {
          toast('unexpected error', "error");
        }
      }
    }
  }
</script>